import * as Sentry from "@sentry/nuxt";

Sentry.init({
	dsn: useRuntimeConfig().public.sentryDsn as string,
	enabled: process.env.NODE_ENV !== "development",
	tracesSampleRate: 0.1,
	integrations: [
		Sentry.vueIntegration({
			tracingOptions: {
				trackComponents: true,
			},
		}),
	],
});
